import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.5 5.375L11.9375 4.71875L9.875 0.5625C9.6875 0.1875 9.34375 0 8.96875 0C8.625 0 8.28125 0.1875 8.09375 0.5625L6.03125 4.71875L1.46875 5.375C0.65625 5.5 0.3125 6.5 0.90625 7.09375L4.21875 10.3125L3.4375 14.8438C3.34375 15.5 3.84375 16 4.4375 16C4.59375 16 4.75 15.9688 4.90625 15.9062L8.96875 13.75L13.0625 15.9062C13.2188 15.9688 13.375 16 13.5312 16C14.125 16 14.625 15.5 14.5312 14.8438L13.75 10.3125L17.0625 7.09375C17.6562 6.5 17.3125 5.5 16.5 5.375ZM12.7188 10.2188L13.5312 15L9.21875 12.75C9.0625 12.6562 8.90625 12.6562 8.75 12.75L4.4375 15L5.3125 9.9375L1.625 6.375L6.4375 5.65625C6.59375 5.625 6.75 5.53125 6.8125 5.375L8.96875 1L11.1562 5.375C11.2188 5.53125 11.375 5.625 11.5312 5.65625L16.3438 6.375L12.875 9.78125C12.75 9.875 12.6875 10.0312 12.7188 10.2188Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgStarMui);
export { ForwardRef as ReactComponent };
